<template>
  <ToastUi/>
  <router-view v-slot="{Component}">
    <Transition @enter="enter" @leave="leave">
      <component :is="Component"/>
    </Transition>
  </router-view>
</template>
<script>
import ToastUi from "@/components/ui/toast/toast-ui.vue";
import gsap from "gsap";
  export default {
    components: {
      ToastUi,
    },
    created(){
      this.$store.dispatch("tryLogin");
    },
    methods: {
      enter(el, done){
            gsap.fromTo(el,{ opacity: 0 }, {
                opacity: 1,
                duration: 0.3,
                ease: "power2.out",
                onComplete: done,
            });
        },
        leave(el, done){
            gsap.to(el, {
                opacity: 0,
                duration: 0.3,
                ease: "power2.in",
                onComplete: done,
            });
        },
    }
  }
</script>